// todo move this file to module
export let ProfileFillRequirementOptions = {
    '1': 'الزامی',
    '0': 'اختیاری',
}